
import { AfterViewChecked, ChangeDetectorRef, Component, DoCheck, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { AssistantService } from '../../services/assistant.service';
import { AssistantRequest } from '../../models/assitant-request';
import { MoovingAssistantIA } from '../../models/assistant';
import { User } from 'src/app/core/auth/models';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { ConversationService } from 'src/app/share/services/conversation.service';
import { Conversation } from 'src/app/share/models/conversation';
import { ToastService } from 'src/app/utils/services/toast.service';

interface AssistantMessage {
  userId: string;
  text: string;
}

@Component({
  standalone: false,
  selector: 'app-ia-assistant',
  templateUrl: './ia-assistant.component.html',
  styleUrls: ['./ia-assistant.component.scss'],
})

export class IaAssistantComponent implements OnInit {
  inputMode: 'text' | 'audio' = 'text';
  recognition: any = null;
  isRecording: boolean = false;
  transcript: string = '';
  trenscriptedMessage: string = '';


  startRecording() {
    if (this.isRecording) return;
    
    this.isRecording = true;
    this.transcript = '';
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (!SpeechRecognition) {
      this.toast.error('El reconocimiento de voz no es compatible con este navegador.');
      this.isRecording = false;
      return;
    }
    this.recognition = new SpeechRecognition();
    this.recognition.lang = 'es-ES';
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.onresult = (event: any) => {
      let interim = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        
        if (event.results[i].isFinal) {
      
          this.transcript += event.results[i][0].transcript;
        } else {
          interim += event.results[i][0].transcript;
        }
      }
      // Actualiza el input de mensaje en tiempo real
      this.trenscriptedMessage = this.transcript + interim;
      
    };
    this.recognition.onerror = (event: any) => {
      this.isRecording = false;
      this.toast.error('Error en el reconocimiento de voz.');
    };
    this.recognition.onend = () => {
      this.isRecording = false;
      // Cuando termina la grabación, asigna la transcripción al input y envía el mensaje
      this.messageInput = this.transcript.trim();
      if (this.messageInput) {
        this.sendMessage();
      }
    };
    this.recognition.start();
  }

   stopRecording() {
    if (this.recognition && this.isRecording) {
      this.recognition.stop();
    }
    this.isRecording = false;
  }

  @ViewChild('bottom') bottom!: ElementRef;

  @Input() user!: User;
  @Input() shouldScrollBottom: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() moovingAssistant!: MoovingAssistantIA;
  moovingAssistantIdTelar: string = '';


  messageInput: string = '';
  @Input() messages: AssistantMessage[] = [];
  showChat: boolean = false;
  chatHiding: boolean = false;
  loading: boolean = false;
  showError: boolean = false;
  isFullscreen = false;
  isMinimizing = false;
  isPage: boolean = false;
  showHistory = true;
  conversations: Conversation[] = [];
  currentConversation!: Conversation;
  loadingMessage: string = '';
  loadingMessages = [
    'El asistente está generando una respuesta, esto puede tardar unos segundos...',
    'Preparando el contexto...',
    'Verificando posibles acciones...',
    'Gracias por tu paciencia, preparando la respuesta...',
    'Verificando los documentos vinculados al asistente...'
  ]


  constructor(private assistantService: AssistantService,
    private auth: AuthService,
    private toast: ToastService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private conversationService: ConversationService,
    private route: ActivatedRoute) { }

  ngOnChanges() {
    this.getConversationsByUserIdAndAssistantId(true);
    this.shouldScrollBottom.subscribe((shouldScroll) => {
      if (shouldScroll) {
        this.scrollToBottom();
        this.shouldScrollBottom.next(false);
      }
    });
  }

  ngOnInit() {

    this.isPage = this.route.snapshot.data['page'] || false;
    this.showChat = true;
    this.isFullscreen = true;
    this.isMinimizing = false;

    if (this.isPage) {
      if (!this.user) {
        const user = this.auth.$user.getValue();
        if (!user) {
          this.router.navigate(['/auth/login'], { queryParams: { returnUrl: this.router.url } });
          return;
        }

        this.user = user;
      }

      if (!this.moovingAssistant) {
        this.moovingAssistantIdTelar = this.route.snapshot.params['idTelar'];
        this.getAssistant();
        this.showChat = true;
        this.isFullscreen = true;
        this.isMinimizing = false;
      }
    }

    // this.getConversationsByUserIdAndAssistantId();


  }


  deleteConversation(conversationsToDelete: Conversation[]) {
    const deleteObservables = conversationsToDelete.map(conversation =>
      this.conversationService.deleteConversation(conversation.id!)
    );
  }


  toggleHistory() {
    this.showHistory = !this.showHistory;
  }

  getAssistant() {
    this.assistantService.getAssistantByIdTelar(this.moovingAssistantIdTelar).subscribe({
      next: assistant => {
        this.moovingAssistant = assistant.records[0];
      },
      error: err => {
        console.error(err);
      }
    });
  }


  toggleFullscreen(event: Event) {
    event.stopPropagation();
    if (!this.isFullscreen) {
      this.isFullscreen = true;
      this.isMinimizing = false;
    } else {
      this.isMinimizing = true;
      setTimeout(() => {
        this.isFullscreen = false;
        this.isMinimizing = false;
      }, 300); // Duración de la animación
    }
  }

  showChatModal() {
    this.showChat = true;
  }

  hideChat() {
    this.showChat = false;
  }

  private scrollToBottom() {
    if (this.bottom) {
      this.bottom.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  sendMessage() {
    
    this.loadingMessage = '';
    this.loading = true;
    const interval = setInterval(() => {
      this.loadingMessage = this.loadingMessages[Math.floor(Math.random() * this.loadingMessages.length)];
    }, 5000);
    this.loadingMessage = 'El asistente está generando una respuesta, esto puede tardar unos segundos...';
    const message = { userId: this.user.id, text: this.isRecording ? this.trenscriptedMessage : this.messageInput };
    this.messages.push(message);
    //this.shouldScrollBottom.next(false);
    this.messageInput = '';
    this.trenscriptedMessage = '';
    this.cd.detectChanges();
    this.shouldScrollBottom.next(true);

    const assistantRequest: AssistantRequest = {
      prompt: message.text,
      idTelar: this.moovingAssistant.idTelar,
      idConversation: this.currentConversation.id!,
      userId: this.user.id!
    }

    this.assistantService.sendMessage(assistantRequest).subscribe({
      next: response => {

        this.messages.push({ userId: 'assistant', text: response as string });
        this.loading = false;
         this.cd.detectChanges();
        this.shouldScrollBottom.next(true);
        
        clearInterval(interval);
      },
      error: err => {
        console.error(err);
        this.showError = true;
        this.loading = false;
        this.shouldScrollBottom.next(true);
        clearInterval(interval);
      }
    });
  }

  getConversationById(conversationId: string) {
    this.conversationService.getConversationById(conversationId).subscribe({
      next: conversation => {
        this.messages = conversation.messages!.map(msg => ({ userId: msg.senderId!, text: msg.text! }));
        this.currentConversation = conversation;
      },
      error: () => {
        this.showError = true;
      }
    });
  }

  getConversationsByUserIdAndAssistantId(initial: boolean = false) {
    this.shouldScrollBottom.next(false);
    this.conversationService.getConversartionsByUserIdAndAssistantId(this.user.id!, this.moovingAssistant.idTelar).subscribe({
      next: conversations => {

        this.conversations = conversations;

        if (initial) {
          if (conversations.length > 0) {
            this.currentConversation = conversations[0];
            this.getConversationById(this.currentConversation.id!);
            return;
          }
          this.openNewConversation();
          return;
        }
        const exists = conversations.find(c => c.id === this.currentConversation.id);

        if (!exists) {
          if (conversations.length === 0) {
            this.openNewConversation();
            return;
          }
          this.currentConversation = this.conversations[0];
        }
        this.getConversationById(this.currentConversation.id!);
      },
      error: err => {
        console.error(err);
      }
    });
  }


  openNewConversation() {
    this.currentConversation = {
      userId: this.user?.id!,
      title: 'Nueva conversación',
      lastMessage: '',
      timestamp: new Date(),
      messages: [],
      idAssistant: this.moovingAssistant?.idTelar,
      idModel: this.moovingAssistant?.llmModelo
    }

    this.conversationService.createConversation(this.currentConversation).subscribe(
      {
        next: (response) => {
          this.currentConversation = response;
          this.getConversationsByUserIdAndAssistantId();
          // this.getConversationById(this.currentConversation.id!);
        },
        error: (error) => {
          console.error(error);
        },
      }
    );
  }


  createNewConversation() {
    this.openNewConversation();
  }

  closeAssistant() {
    if (!this.isPage) {
      this.assistantService.setCurrentAssistant(null);
    }
  }

  startVoiceInput() {
  }
}
